<template>
  <main id="outbound-units-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          <el-dropdown @command="handleChangeView" trigger="click">
          <span class="el-dropdown-link app-view-title">
            {{ $t(outboundUnits.currentView) }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="activeUnits" v-bind:class="{ 'view-active': outboundUnits.currentView === activeUnits }">{{ $t(activeUnits) }}</el-dropdown-item>
            <el-dropdown-item :command="deletedUnits" v-bind:class="{ 'view-active': outboundUnits.currentView === deletedUnits }">{{ $t(deletedUnits) }}</el-dropdown-item>
            <el-dropdown-item :command="allUnits" v-bind:class="{ 'view-active': outboundUnits.currentView === allUnits }">{{ $t(allUnits) }}</el-dropdown-item>
            <el-dropdown-item :command="activeUnitsWithoutLoad" v-bind:class="{ 'view-active': outboundUnits.currentView === activeUnitsWithoutLoad }">{{ $t(activeUnitsWithoutLoad) }}</el-dropdown-item>
            <el-dropdown-item :command="activeUnitsWithoutShipment" v-bind:class="{ 'view-active': outboundUnits.currentView === activeUnitsWithoutShipment }">{{ $t(activeUnitsWithoutShipment) }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" class="default-section-title">
              {{ $t('outbound.units.summaryTitle') }}
              <span class="total-units-title" v-show="outboundUnits.total > 0"> {{ $t('warehouse.orderEntry.totalUnits') }}</span>
              <span class="total-units-span" v-show="outboundUnits.total > 0"> {{ outboundUnits.total }}</span>
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="16" class="default-section-actions text-align-end">
              <unit-actions-dropdown :validate-search="validateSearch" />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import UnitActionsDropdown from '@/views/outbound/units/components/UnitActionsDropdown';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';

export default {
  name: 'OutboundUnits',
  components: {
    UnitActionsDropdown,
    SearchFilter,
    SearchSummary,
  },
  computed: {
    ...mapGetters([
      'outboundUnits'
    ])
  },
  data() {
    return {
      activeUnits: 'outbound.units.activeUnits',
      deletedUnits: 'outbound.units.deletedUnits',
      allUnits: 'outbound.units.allUnits',
      activeUnitsWithoutLoad: 'outbound.units.activeUnitsWithoutLoad',
      activeUnitsWithoutShipment: 'outbound.units.activeUnitsWithoutShipment'
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    },
    validateSearch() {
      return this.$refs.searchFilter.validateSearch();
    },
    async handleChangeView(view) {
      // Default filters activeUnits
      const viewFilters = {
        active: true,
        loadIsNull: false,
        shipmentIsNull: false,
      };
      switch (view) {
        case this.deletedUnits:
          viewFilters.active = false;
          break;
        case this.allUnits:
          viewFilters.active = null;
          break;
        case this.activeUnitsWithoutLoad:
          viewFilters.loadIsNull = true;
          break;
        case this.activeUnitsWithoutShipment:
          viewFilters.shipmentIsNull = true;
          break;
        default:
          break;
      }
      this.$store.dispatch('outboundUnits/setCurrentView', view);
      await this.$store.dispatch('outboundUnits/search', viewFilters);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.total-units-title {
  margin-left: 20px;
}

.total-units-span {
  font-size: 13px;
  font-weight: 400;
  color: #606266;
}
.el-dropdown {
  padding-bottom: 1px;
  &:hover {
    border-bottom: solid 1px #43425d;
    padding-bottom: 0px;
  }
  .el-dropdown-link {
    cursor: pointer;
  }
}
.view-active {
  background-color: #e5f2ff;
  color: #409EFF;
}
</style>
